export default {
    data() {
        return {
            valid: {
                system_payment_method: false
            },
            success: {
                system_payment_method: false
            },
            error: {
                system_payment_method: ""
            },
            errorMessages: {
                systemPaymentMethodRequired: {
                    el: "",
                    en: "System Payment Method is required",
                    it: ""
                }
            }
        };
    },

    computed: {
        formValid() {
            return this.mode === 1
                ? this.valid.system_payment_method
                : true;
        }
    },

    methods: {
        validateSystemPaymentMethod() {
            if (!this.paymentMethod.system_payment_method_id) {
                this.error.system_payment_method = this.errorMessages.systemPaymentMethodRequired[
                    this.lang
                ];
            } else {
                this.error.system_payment_method = "";
            }
        }
    },

    watch: {
        ["paymentMethod.system_payment_method_id"]: {
            immediate: true,
            handler(val) {
                this.valid.system_payment_method = !!val;
                this.success.system_payment_method = !!val;
            }
        },

        resetSuccess(val) {
            if (val) {
                this.success = {
                    system_payment_method: false
                };

                this.setResetSuccess(false);
            }
        },

        resetValidation: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.error = {
                        system_payment_method: ""
                    };

                    this.setResetValidation(false);
                }
            }
        }
    }
};
